import React from 'react';
import authService from '../../services/authService';
import { useNavigate } from 'react-router-dom';

const Logout = () => {
  const navigate = useNavigate();

  async function signOutCognito() {
    await authService.logout();
    navigate('/'); // Redirects to home page
  }

  React.useEffect(() => {
    signOutCognito();
    console.log('%%%%%');
  }, []);

  return null;
};

export default Logout;
